import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageWrapper, Loader, Alert, Pagination } from '../../components';
import Actions, { thunks } from '../../redux/modules/agents';
import UserActions, { thunks as userThunks } from '../../redux/modules/users';
import { Link } from 'react-router-dom';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import FranchiseModal from './components/franchiseModal';

const DEFAULT_COUNTRY_CODE = '91';

class Agents extends React.Component {
    state = {
        agentToDelete: null,
        agentToMark: null,
        userToUpdate: null

    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(thunks.getAgents());
    }

    markAgent = agent => {
        this.setState({ agentToMark: agent })
    }

    deleteAgent = agent => {
        this.setState({ agentToDelete: agent })
    }

    onNext = () => {
        const { dispatch } = this.props;
        dispatch(thunks.loadMoreAgents());
    }

    onStatusChange = (e, id) => {
        const { dispatch } = this.props;
        let items = this.props.list;
        let item = items.find(o => o.id === id);
        item.userState = e ? 1 : 2;
        this.setState({ list: items });
        const body = {
            userId: id,
            userState: e ? 1 : 2
        }
        dispatch(thunks.changeUserStatus(body));
    }

    handleDeleteAgent = () => {
        const { dispatch } = this.props;
        const { agentToDelete } = this.state;
        dispatch(thunks.deleteAgent(agentToDelete.id));
        this.setState({
            agentToDelete: null,
        })
    }

    handleMarkAgent = () => {
        const { dispatch } = this.props;
        const { agentToMark } = this.state;
        dispatch(thunks.markAgent(agentToMark.id));
        this.setState({
            agentToMark: null,
        })
    }

    onEditFranchise = userToUpdate => {
        const { updateProperty } = this.props;
        this.setState({ updateUser: userToUpdate });
        this.setState({ userToUpdate }, () => {
            updateProperty('showFranchiseModal', true);
        })
    }

    onHideFranchiseModal = () => {
        const {  updateProperty } = this.props;
        updateProperty('showFranchiseModal', false);
    }

    updateFranchise = user => {
        const { dispatch } = this.props;
        const { updateUser } = this.state;
        const body = {
            ...user,
            userId:updateUser.id,
            countryCode: DEFAULT_COUNTRY_CODE,
        };
        dispatch(thunks.updateFranchise(body));
    }
    viewPurchaseHistory = user => {
        console.log(user);
        this.props.history.push(`/purchase-history/${user.id}/${user.name}`)
    }

    viewLeads = user => {
        console.log(user);
        this.props.history.push(`/leads/${user.id}`)
    }
    

    render() {
        const {
            list,
            loading,
            error,
            updateProperty,
            verificationStatus,
            nextPageToken,
            loadingData,
            userData,
            showFranchiseModal,
            updateUserProperty,
        } = this.props;
        const { agentToDelete, agentToMark, userToUpdate } = this.state;
        return (
            <PageWrapper title="Franchise Owner">
                <Loader show={loading} />
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Franchise Owner"
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row align-items-center justify-content-end  pb-2">
                                        {/* <div className="col-auto">
                                            <div className="form-group">
                                                <label>Status</label>
                                                <select
                                                    className="form-control"
                                                    value={verificationStatus}
                                                    onChange={this.onStatusChange}>
                                                    {AGENT_VERIFICATION_STATUS.map(status => <option key={status.value} value={status.value}>{status.name}</option>)}
                                                </select>
                                            </div>
                                        </div> */}
                                        <div className="col-auto">
                                            <Link to={`/add-user/${3}`}>
                                                <button className="btn btn-primary">Add</button>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    {/* <th>Image</th> */}
                                                    <th>Name</th>
                                                    <th>Phone</th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    list.length ? (
                                                        list.map(agent => (
                                                            <tr key={agent.id}>
                                                                <td>{agent.id}</td>
                                                                {/* <td>
                                                                    {agent.profilePicture ? <img src={agent.profilePicture} alt="profile" width="50px" /> : '-'}
                                                                </td> */}
                                                                <td>{agent.name}</td>
                                                                <td>{'+' + agent.countryCode + '-' + agent.phoneNumber}</td>
                                                                <td>
                                                                    {verificationStatus == 2 && (
                                                                        <button title="Mark as Franchise" className="btn btn-xs btn-info mr-2" onClick={() => this.markAgent(agent)}>
                                                                            <i className="fa fa-check" />
                                                                        </button>
                                                                    )}
                                                                    <button title="Delete Franchise" className="btn btn-xs btn-danger" onClick={() => this.deleteAgent(agent)}>
                                                                        <i className="fa fa-trash" />
                                                                    </button>
                                                                    <button title="View User" className="btn btn-xs btn-info ml-2"  onClick={() => this.onEditFranchise(agent)}>
                                                                        <i className="fa fa-pencil" />
                                                                    </button>
                                                                    <span className="ml-2">
                                                                        <BootstrapSwitchButton checked={agent.userState == 1} onstyle="success" offstyle="danger" size="xs" onChange={(e) => this.onStatusChange(e, agent.id)} />
                                                                    </span>
                                                                        <button title="View User" className="btn btn-xs btn-dark ml-2" onClick={() => this.viewPurchaseHistory(agent)}>
                                                                            <i className="fa fa-eye" />
                                                                        </button>
                                                                        <button title="View Leads" className="btn btn-xs btn-outline-success ml-2" onClick={() => this.viewLeads(agent)}>
                                                                            View Leads
                                                                        </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="5" className="text-center">No Records Found</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        nextPageToken={nextPageToken}
                                        onNext={this.onNext}
                                    />
                                    <Alert
                                        show={!!agentToDelete}
                                        onHide={() => this.setState({ agentToDelete: null })}
                                        title="Delete Franchise"
                                        message={`Are you sure you want to delete Franchise ID: ${(agentToDelete || {}).id}?`}
                                        onSubmit={this.handleDeleteAgent}
                                    />
                                    <Alert
                                        show={!!agentToMark}
                                        onHide={() => this.setState({ agentToMark: null })}
                                        title="Mark as Franchise"
                                        message={`Are you sure you want to mark ID ${(agentToMark || {}).id} as an Franchise?`}
                                        onSubmit={this.handleMarkAgent}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FranchiseModal
                    show={showFranchiseModal}
                    onHide={this.onHideFranchiseModal}
                    updateFranchise={this.updateFranchise}
                    data={userToUpdate}
                />
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    agents: {
        loading,
        error,
        list,
        verificationStatus,
        nextPageToken,
        showFranchiseModal
    },
    users: {
        loadingData,
        data: userData,
    }
}) => ({
    loading,
    error,
    list,
    verificationStatus,
    nextPageToken,
    loadingData,
    userData,
    showFranchiseModal,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
    updateUserProperty: bindActionCreators(UserActions, dispatch).updateProperty,
});

export default connect(mapStateToProps, mapDispatchToProps)(Agents)